<div class="update-container">
    @if (updateAlertDisplayed()) {
        <div class="flex align-items-center justify-content-center p-2 gap update-alert">
            <strong>{{ 'common.newVersionReleased' | translate }}</strong>

            <app-button
                [label]="'common.upgrade' | translate"
                severity="danger"
                [size]="'small'"
                (clickEvent)="loadNewVersion()"
            ></app-button>
        </div>
    }

    @if (isOffline()) {
        <div class="flex align-items-center justify-content-center p-2 offline-alert">
            <strong>{{ 'common.youAreInOfflineMode' | translate }}</strong>
        </div>
    }
</div>
